module.exports = require("write-file-webpack-plugin");